// extracted by mini-css-extract-plugin
export default {"root":"IconAlert_root__bbji9"};